import { DEFAULT_LOCALE, languageToi18nCode } from "@pandas/core-ui";
import { configuratorApi } from "@/services";

export async function fetchPartnerDefaultLocale(partnerCode: string): Promise<string> {
	const config = await configuratorApi.getConfig(partnerCode);
	const defaultLanguageName = config?.languages[0];
	if (!defaultLanguageName) return DEFAULT_LOCALE;
	return languageToi18nCode(defaultLanguageName) ?? DEFAULT_LOCALE;
}
